import { useMutation } from "react-query";
import { buildRequestHeaders, showMutationAlert } from "utils/helpers";
import { BACKEND_DOMAIN} from "utils/constants";
import useAlert from "hooks/useAlert";
import { useAccessToken } from "hooks/useAccessToken";


const useMutationExportBuildingsForFilterset = () => {
    const alert = useAlert();
    const accessToken = useAccessToken();
    

    return useMutation({
        mutationFn: async ({filtersetUid, reportedVsPublished}:{filtersetUid: string, reportedVsPublished: string}) => {
            const URL = `${BACKEND_DOMAIN}/buildings/filtered/${filtersetUid}/export?reported_vs_published=${reportedVsPublished}`
            const response = await fetch(URL, {
                method: "POST",
                headers: buildRequestHeaders(accessToken),
            });
            if (!response.ok) {
                throw new Error(`Error ${response.status}`);
            }
            return response.json();
        },
        onError: (error) => {
            showMutationAlert(error, alert);
        },
        onMutate: () => {
            alert.success("Export started...");
        }
    });
};

export default useMutationExportBuildingsForFilterset;
